import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Competitor from './icon-competitor.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Competitor {...validProps} />;
}
SvgComponent.iconName = 'competitor';

export const CompetitorIcon = svgIconWrapper(SvgComponent);
